// 会员分组列表
export const MEMBER_GROUP_LIST_PAGE_UUID =
  'e1aececa-38de-46a2-807d-a3739c16f5f9'

// 会员分组管理权限
export const MEMBER_GROUP_MANAGER_ACTION_UUID =
  'c7437669-9ec3-4314-a5c9-6704f7ca2de2'
